import Link from "./Link";
import Default from "./Default";
import Text from "./Text";
import Iframe from "./Iframe";
import Math from "./Math";
import Video from "./Video";

export default {
  Link,
  Default,
  Text,
  Iframe,
  Math,
  Video
};
